module.exports = __webpack_public_path__ + "static/img/community-and-service-learning-thumbnail.a8690f1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/community-and-service-learning-thumbnail.jpg
// module id = e5AR
// module chunks = 1